export default {"src":"/_next/static/media/link-off-circle.3925de61.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};